/*
 *
 * TransactionReversePopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 09-Jun-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (
    <PortalMessage
      id='t.app.homepage.quickLinksWidget.reverseTransaction.title'
      defaultMessage='Storna transazione'
    />
  ),
  cardTitle: (
    <PortalMessage
      id='t.app.transactions.reversePopup.cardTitle'
      defaultMessage='Cerca la transazione'
    />
  ),
  cardSubtitle: (
    <PortalMessage
      id='t.app.transactions.reversePopup.cardSubtitle'
      defaultMessage='Per stornare è necessario effettuare una ricerca. <br /> La ricerca verrà effettuata sui punti vendita selezionati, l’intervallo massimo che puoi selezionare è 12 mesi.'
    />
  ),
  dataRangeStartLabel: (
    <PortalMessage
      id='t.app.transactions.filtersModal.dataRangeStartLabel'
      defaultMessage='Data inizio'
    />
  ),
  dataRangeEndLabel: (
    <PortalMessage
      id='t.app.transactions.filtersModal.dataRangeEndLabel'
      defaultMessage='Data fine'
    />
  ),
  primaryButtonLabel: (
    <PortalMessage
      id='t.app.transactions.reversePopup.primaryButtonLabel'
      defaultMessage='Cerca'
    />
  ),
  close: (
    <PortalMessage
      id='t.app.close'
      defaultMessage='Chiudi'
    />
  ),
  cardNumberLabel: (
    <PortalMessage
      id='t.app.transactions.reversePopup.cardNumberLabel'
      defaultMessage='Numero carta'
    />
  ),
  authorizationCodeLabel: (
    <PortalMessage
      id='t.app.transactions.reversePopup.authorizationCodeLabel'
      defaultMessage='Codice autorizzazione'
    />
  ),
  placeholderPan: (
    <PortalMessage
      id='t.app.transactions.reversePopup.placeholderPan'
      defaultMessage='Ultime 4 cifre carta'
    />
  ),
  placeholderAuthorisationCode: (
    <PortalMessage
      id='t.app.transactions.reversePopup.placeholderAuthorisationCode'
      defaultMessage='Inserisci codice autorizzazione'
    />
  ),
  customDateRequiredFieldError: (
    <PortalMessage
      id='t.app.error.requiredField'
      defaultMessage='Il campo è obbligatorio'
    />
  ),
  customDateInvalidError: (
    <PortalMessage
      id='t.app.transactions.filtersModal.customDateInvalidError'
      defaultMessage='Data inserita non valida'
    />
  ),
  customDateFormatFieldError: (
    <PortalMessage
      id='t.app.transactions.detailTransactionAggregates.dateInvalidError'
      defaultMessage='Formato data GG/MM/AAAA'
    />
  ),
  dateLimitError: () => (
    <PortalMessage
      id='t.app.transactions.filtersModal.dateLimitError'
      defaultMessage='Lo storico ha un massimo di {monthsLimit} mesi'
      values={{ monthsLimit: 12 }}
    />
  ),
  customDateRangeEndDatePriorToTheStartDateReverse: (
    <PortalMessage
      id='t.app.transactions.filtersModal.customDateRangeEndDatePriorToTheStartDateReverse'
      defaultMessage='La data di inizio deve essere precedente a quella di fine'
    />
  ),
  customDateEndDateAfterTodayError: (
    <PortalMessage
      id='t.app.transactions.filtersModal.customDateEndDateAfterTodayError'
      defaultMessage='La data di fine non può essere successiva ad oggi'
    />
  ),
  customDateStartDateTooOldError: (
    <PortalMessage
      id='t.app.transactions.filtersModal.customDateStartDateTooOldError'
      defaultMessage='L’intervallo massimo è 12 mesi.'
    />
  ),
  customDateRangeEndDatePriorToTheStartDate: (
    <PortalMessage
      id='t.app.transactions.filtersModal.customDateRangeEndDatePriorToTheStartDate'
      defaultMessage='La data di fine deve essere successiva a quella di inizio'
    />
  ),
  customAuthCodeFormatFieldError: (
    <PortalMessage
      id='t.app.transactions.reversePopup.customAuthCodeFormatFieldError'
      defaultMessage='Il codice deve essere di 5 o 6 caratteri alfanumerici'
    />
  ),
  customPanFormatFieldError: (
    <PortalMessage
      id='t.app.transactions.reversePopup.customPanFormatFieldError'
      defaultMessage='Il numero carta deve essere di 4 cifre'
    />
  ),
  helperTextAuthCode: (
    <PortalMessage
      id='t.app.transactions.reversePopup.helperTextAuthCode'
      defaultMessage='Formato: 5 o 6 caratteri alfanumerici'
    />
  )
}

export default formattedMessage
